import router from '../router'
import store from '../store'

export default{
    install(Vue, axiosInstance){
        // 设置请求拦截器
        axiosInstance.interceptors.request.use(
            config => {
                // 在请求头中添加token
                const token = localStorage.getItem('token')
                if(token){
                    config.headers.Authorization = 'Bearer ' + token
                }
                return config
            },
            err => {
                return Promise.reject(err)
            }
        )

        // 设置响应拦截器
        axiosInstance.interceptors.response.use(
            response => {
                // 如果是二进制数据，直接返回整个 response 对象，或者直接返回 data
                if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
                    return response;
                }

                const res = response.data;
                
                // 1. 业务成功：直接返回 data 字段
                // 页面层如果读取 response.message，读取的是 data.message，
                // 不是顶层 ApiResponse.msg。
                if (res.code === 200) {
                    return res.data;
                }
                
                // 2. 业务失败：抛出错误，进入 catch 分支
                // 可以在这里统一处理 401 跳转
                if (res.code === 401) {
                    store.dispatch('logout')
                }
                
                return Promise.reject(res); // 将整个响应对象作为错误抛出，以便获取 msg
            },
            error => {
                console.log(error)
                if (error.response) {
                    // The request was made and the server responded with a status code that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);

                    // 如果响应状态码为401，说明token过期，清除token和user
                    if(error.response.status === 401){                        
                        store.dispatch('logout')
                        router.replace({
                            path: "/login",
                            query: { redirect: router.currentRoute.fullPath }
                          });
                    }
                        
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
                return Promise.reject(error);
            }
        )
    }
}
